import { Money } from "./Money";

import numeral from "numeral";
import type { IMoneyFormatterService } from "../services/IMoneyFormatterService";
import { CurrencyOption } from "./api";

// numeral delegate, for webpack
// type ND = (input?: any) => numeral;

export class MoneyFormatter implements IMoneyFormatterService
{
    
    //protected locality: string = "es-MX";
    //protected locality: string = "en-US";
    //protected currency: string = "MXN";
    //protected currency: string = "USD";

    protected denomCents: number = 0.01;

    protected numberFormat: string = "0,0[.0]";
    protected quantityFormat: string = "0,0";
    protected currencyFormat: string = "0,0.00"
    protected shortCurrencyFormat: string = "0,0";

    public static readonly Instance: MoneyFormatter = new MoneyFormatter();

    public static readonly DefaultCurrency: CurrencyOption =
    {
        Name: "No currency",
        Short: "",
        Prefix: "",
        Suffix: "",
        DecimalSeparator: ".",
        ThousandsSeparator: ","
    };

    protected currency: CurrencyOption = {...MoneyFormatter.DefaultCurrency};

    public constructor(denomCents?: number)
    {
        this.denomCents = denomCents ?? this.denomCents;
    }

    // public constructor() {}

    
    public SetCurrency(currency: CurrencyOption)
    {
        this.currency = {...currency};

        this.numberFormat = `0,0[.0]`;
        this.quantityFormat = `0,0`;
        this.currencyFormat = `0,0.00`
        this.shortCurrencyFormat = `0,0`;


        console.log("Setting currency", this.currency);

        let n = 1000000;
        console.log(`number         ${this.numberFormat} ${n} => ${numeral(n).format(this.numberFormat)}`);
        console.log(`quantity       ${this.quantityFormat} ${n} => ${this.FormatQuantity(n)}`);
        console.log(`currency       ${this.currencyFormat} ${n} => ${this.FormatCurrency(n)}`);
        console.log(`currency short ${this.shortCurrencyFormat} ${n} => ${this.FormatCurrencyShort(n)}`);


        // load a locale
        numeral.reset();
        numeral.locales["custom"] = {
            delimiters: {
                thousands: currency.ThousandsSeparator,
                decimal: currency.DecimalSeparator
            },
            abbreviations: {
                thousand: 'k',
                million: 'm',
                billion: 'b',
                trillion: 't'
            },
            ordinal : function (number) {
                return "";
            },
            currency: {
                symbol: ''
            }
        };

        // switch between locales
        numeral.locale('custom');
    }

    public SetDenom(denomCents: number)
    {
        this.denomCents = denomCents;
    }

    public SetLocality(locality: string)
    {
        //this.locality = locality;
        //this.numberFormat = new Intl.NumberFormat(this.locality);
        //this.currencyFormat = new Intl.NumberFormat(this.locality, {style: 'currency', currency: this.currency});
    }

    public FormatCreditCurrentDenom(cents: Money | number): string
	{
		if (typeof(cents) === 'number')
			return "" + this.FormatQuantity(this.CentsToCredit(cents));
		else
			return "" + this.FormatQuantity(this.CentsToCredit(cents.InCents));
	}

    public FormatCreditWithDenom(cents: Money | number, denom: Money | number): string
	{
		if (typeof(cents) === 'number')
			return "" + this.FormatQuantity(this.CentsToCreditWithDenom(cents, denom));
		else
			return "" + this.FormatQuantity(this.CentsToCreditWithDenom(cents.InCents, denom));
	}

	public CentsToCredit(cents: Money | number): number
	{
		// floor the value, not to give more credits than it actually is
		if (typeof(cents) === 'number')
			return Math.floor(cents / this.denomCents);
		else
			return Math.floor(cents.InCents / this.denomCents);
	}

    public CreditToCents(credit: number): Money
    {
        return <Money>{
            InCents: Math.floor(credit * this.denomCents)
        };
    }

    public CreditToCentsWithDenom(credit: number, denom: Money | number): Money
    {
        let denomCents: number = 0;
        if (typeof(denom) === 'number')
            denomCents = denom;
        else
            denomCents = denom.InCents;

        return <Money>{
            InCents: Math.floor(credit * denomCents)
        };
    }

    public CentsToCreditWithDenom(cents: Money | number, denom: Money | number): number
	{
		// floor the value, not to give more credits than it actually is

        let denomCents: number = 0;
        if (typeof(denom) === 'number')
            denomCents = denom;
        else
            denomCents = denom.InCents;

		if (typeof(cents) === 'number')
			return Math.floor(cents / denomCents);
		else
			return Math.floor(cents.InCents / denomCents);
	}

	public FormatCurrency(cents: Money | number): string
	{
		if (typeof(cents) === 'number')
			return (this.currency?.Prefix ?? "")  + numeral(cents / 100).format(this.currencyFormat) + (this.currency?.Suffix ?? "");
		else
			return (this.currency?.Prefix ?? "") + numeral(cents.InCents / 100).format(this.currencyFormat) + (this.currency?.Suffix ?? "");
    }

    public FormatCurrencyEmptySymbol(cents: Money | number): string
    {
        if(typeof(cents) === 'number')
            return numeral(cents/100).format(this.currencyFormat);
        else
            return numeral(cents.InCents/100).format(this.currencyFormat);
    }

    public FormatCurrencyShort(cents: Money | number): string
	{
        let c: number = 0;
		if (typeof(cents) === 'number')
            c = cents;
			//return (numeral as any as ND)(cents / 100).format(this.currencyFormat);
		else
            c = cents.InCents;
			//return (numeral as any as ND)(cents.InCents / 100).format(this.currencyFormat);

        c = c / 100;
        if (c > 1000)
        {
            return (this.currency?.Prefix ?? "") + numeral(c / 1000).format(this.shortCurrencyFormat) + "K" + (this.currency?.Suffix ?? "");
        }

        return (this.currency?.Prefix ?? "") + numeral(c).format(this.shortCurrencyFormat) + (this.currency?.Suffix ?? "");
        //else if (c > 1000000)
    }

    public FormatQuantity(n: number): string
    {
        return numeral(n).format(this.quantityFormat);
    }
/*
    public FormatNumber(number: number): string
    {
        return numeral(number).format(this.numberFormat);
    }
*/
    public GetDenom(): number
    {
        return this.denomCents;
    }

    public GetLocality(): string
    {
        //return this.locality;
        throw "Not implemented";
    }
}

export const moneyFormatter: MoneyFormatter = MoneyFormatter.Instance;
